// Мобайл горим (/m/*) — утсанд зориулсан бүрхүүл: дээд бар + доод таб.
// Ширээний layout (sidebar, header)-ыг бүрэн орлоно.
import React, { useContext, useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Drawer, Switch, message } from "antd";
import { FiCpu, FiHome, FiCalendar, FiCheckSquare, FiGrid, FiMenu, FiLogOut, FiMonitor, FiDownload, FiSun, FiCamera, FiChevronRight, FiBell } from "react-icons/fi";
import { AuthContext } from "contexts";
import { useAccess } from "contexts/access";
import { onInstallable, promptInstall, isStandalone, isIOS } from "utils/pwa";
import logo from "assets/images/logo.png";
import ls from "utils/ls";
import { canElementary } from "./access";
import { pushState, enablePush, disablePush, testPush } from "utils/push";

// Доод таб — өдөр бүр хэрэглэдэг 3 хуудас (+ админд AI чат) + "Цэс". Бусад нь (QR, захиалга, бага анги) цэсэнд.
const TABS = [
  { to: "/m", label: "Өнөөдөр", icon: FiHome, end: true },
  { to: "/m/schedule", label: "Хуваарь", icon: FiCalendar },
  { to: "/m/course", label: "Хичээл", icon: FiCheckSquare },
];
// "AI чат" — зөвхөн админ (Эрх ба роль засах эрхтэй)
const AI_TAB = { to: "/m/ai", label: "AI чат", icon: FiCpu };
// "Бага анги" — зөвхөн бага ангийн багш, удирдлага
const MENU = [
  { to: "/m/scan", label: "QR ирц", icon: FiCamera },
  { to: "/m/booking", label: "Танхим захиалга", icon: FiGrid },
  { to: "/m/elementary", label: "Бага анги", icon: FiSun, show: canElementary },
];

export default function MobileShell() {
  const { state, action } = useContext(AuthContext);
  const { can } = useAccess();
  const tabs = can("access", "edit") ? [...TABS, AI_TAB] : TABS;
  const navigate = useNavigate();
  const p = state?.userInfo?.profile || {};
  const [open, setOpen] = useState(false);
  const [installable, setInstallable] = useState(false);
  useEffect(() => onInstallable(setInstallable), []);
  // Push мэдэгдэл: on | off | denied | unsupported
  const [push, setPush] = useState("off");
  const [pushBusy, setPushBusy] = useState(false);
  useEffect(() => { if (open) pushState().then(setPush).catch(() => setPush("unsupported")); }, [open]);
  const togglePush = (on) => {
    setPushBusy(true);
    (on ? enablePush() : disablePush())
      .then((st) => { setPush(st); if (st === "on") testPush().catch(() => {}); })
      .catch((e) => { message.error(e.message || "Алдаа гарлаа"); pushState().then(setPush).catch(() => {}); })
      .then(() => setPushBusy(false));
  };
  const initials = (p.firstName || "?").charAt(0).toUpperCase();
  const menu = MENU.filter((t) => !t.show || t.show(p));
  const { pathname } = useLocation();
  const inMenu = menu.some((m) => pathname.startsWith(m.to));

  return (
    <div className="min-h-screen bg-[#f4f5f9]">
      <header className="m-topbar fixed inset-x-0 top-0 z-50 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="h-14 px-4 flex items-center justify-between">
          <img src={logo} alt="Tomujin" className="h-8 w-auto object-contain" />
          <button onClick={() => setOpen(true)} className="flex items-center gap-2 h-10 pl-1 pr-2 rounded-full hover:bg-gray-100">
            <span className="h-8 w-8 rounded-full bg-primary text-white font-bold flex items-center justify-center text-sm">{initials}</span>
            <span className="text-left leading-tight">
              <span className="block text-sm font-semibold text-gray-900 max-w-[110px] truncate">{p.firstName}</span>
              <span className="block text-[11px] text-gray-400">{p.role}</span>
            </span>
          </button>
        </div>
      </header>

      <main className="m-content px-4 max-w-2xl mx-auto">
        <Outlet />
      </main>

      <nav className="m-tabbar fixed inset-x-0 bottom-0 z-50 bg-white border-t border-gray-100">
        <div className={`grid ${tabs.length > 3 ? "grid-cols-5" : "grid-cols-4"}`}>
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end}
              className={({ isActive }) => `flex flex-col items-center justify-center h-16 gap-1 text-[11px] font-medium ${isActive ? "text-primary" : "text-gray-400"}`}>
              {({ isActive }) => (
                <>
                  <span className={`h-7 w-7 rounded-xl flex items-center justify-center ${isActive ? "bg-primary/10" : ""}`}><t.icon size={20} /></span>
                  {t.label}
                </>
              )}
            </NavLink>
          ))}
          <button onClick={() => setOpen(true)} className={`flex flex-col items-center justify-center h-16 gap-1 text-[11px] font-medium ${inMenu ? "text-primary" : "text-gray-400"}`}>
            <span className={`h-7 w-7 rounded-xl flex items-center justify-center ${inMenu ? "bg-primary/10" : ""}`}><FiMenu size={20} /></span>Цэс
          </button>
        </div>
      </nav>

      <Drawer open={open} onClose={() => setOpen(false)} placement="right" width={300} bodyStyle={{ padding: 0 }}>
        <div className="px-5 py-5 flex items-center gap-3 border-b border-gray-100">
          <span className="h-12 w-12 rounded-full bg-primary text-white font-bold flex items-center justify-center text-lg">{initials}</span>
          <div>
            <div className="font-semibold">{p.firstName} {p.lastName}</div>
            <div className="text-xs text-gray-400">{p.role}{p.position ? ` · ${p.position}` : ""}</div>
          </div>
        </div>
        {menu.map((m) => (
          <button key={m.to} onClick={() => { setOpen(false); navigate(m.to); }}
            className={`w-full flex items-center gap-3 px-5 h-14 text-[15px] font-medium border-b border-gray-50 ${pathname.startsWith(m.to) ? "text-primary bg-primary/5" : "text-gray-800"}`}>
            <m.icon size={20} className={pathname.startsWith(m.to) ? "" : "text-gray-400"} /><span className="flex-1 text-left">{m.label}</span><FiChevronRight className="text-gray-300" />
          </button>
        ))}
        <div className="h-3 bg-gray-50" />
        <div className="flex items-center gap-3 px-5 h-14 border-b border-gray-50">
          <FiBell size={20} className="text-gray-400" />
          <span className="flex-1">
            <span className="block text-[15px] font-medium text-gray-800">Мэдэгдэл</span>
            <span className="block text-[11px] text-gray-400">
              {push === "denied" ? "Браузерын тохиргооноос зөвшөөрнө үү" : push === "unsupported" ? (isIOS() && !isStandalone() ? "Эхлээд апп болгож суулгана уу" : "Энэ төхөөрөмж дэмжихгүй") : "Танхим захиалга, өдөр өнжүүлэх хүсэлт"}
            </span>
          </span>
          <Switch checked={push === "on"} loading={pushBusy} disabled={push === "denied" || push === "unsupported"} onChange={togglePush} />
        </div>
        <button onClick={() => { setOpen(false); ls.set("forceDesktop", 1); navigate("/"); }} className="w-full flex items-center gap-2 px-5 py-3 text-sm font-medium text-gray-700 border-b border-gray-50"><FiMonitor /> Ширээний горим руу</button>
        {installable && !isStandalone() && (
          <button onClick={() => { setOpen(false); promptInstall(); }} className="w-full flex items-center gap-2 px-5 py-3 text-sm font-medium text-primary border-b border-gray-50"><FiDownload /> Апп болгож суулгах</button>
        )}
        {isIOS() && !isStandalone() && (
          <div className="px-5 py-3 text-xs text-gray-400 border-b border-gray-50">iPhone: Safari дээр <b>Share</b> → <b>Add to Home Screen</b></div>
        )}
        <button onClick={() => action.logout()} className="w-full flex items-center gap-2 px-5 py-3 text-sm font-medium text-red-500"><FiLogOut /> Гарах</button>
      </Drawer>
    </div>
  );
}
